import request from './request';

const paymentService = {
  getAll: (params) => request.get('dashboard/admin/payments', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/payments/${id}`, { params }),
  create: (data) => request.post('dashboard/admin/payments', data),
  update: (id, data) => request.put(`dashboard/admin/payments/${id}`, data),
  setActive: (id) =>
    request.post(`dashboard/admin/payments/${id}/active/status`, {}),
  delete: (id) => request.delete(`dashboard/admin/payments/${id}`),
};

export default paymentService;
